<div class="main-container" *ngIf="!isLoading && isFullScreen">

  <div [class.main-left-container]="!isRightPanelMinimized"
    [class.main-left-container-expanded]="isRightPanelMinimized">
    <div class="content-container">
      <!-- PROFILE & CASES -->
      <div class="general-container" *ngIf="patientInformation">
        <div class="general-content-container profile-container">
          <div class="profile-image" (click)="activateImageView()">
            <app-file-manager-view #imageView [width]="150" [height]="150" [roundImage]="false" [roundCorners]="true"
              [orientation]="'fixed'" viewType="single" previewType="patient" [LOCID]="LOCID"
              enumDocumentTypeID="0000001C-1000-0000-0000-000000000003"
              [enumDocumentTags]="[DOCUMENT_TAG.PatientPicture]" [PatientId]="PatientId"></app-file-manager-view>
          </div>
          <div class="profile-info">
            <div class="profile-action-buttons">
              <div class="warning-icon-container" [matTooltip]="patientMissingInfo">
                <i *ngIf="!patientInformationComplete" class="material-icons warning-icon"
                  alt="Patient information incomplete">warning</i>
              </div>
              <div class="button" style="width: 60px;float: right;" color="primary" (click)="editProfilePressed()">Edit
              </div>
            </div>
            <!--PROFILE DATA-->
            <div>
              <div style="color: var(--accented-text-color); font-size: 18px;">
                {{patientInformation.fullname}}
              </div>
              <div class="patient-info">
                <span style="color: var(--tdo-light-gray);">Patient # {{Patient?.PatientNO}}</span>
                <div class="appointment-data">
                  <ng-container>
                    {{ patientBirthday?.format('DD MMM, YYYY') }}<br />
                    {{ patientBirthday? moment().diff(patientBirthday,'years') : '--'}} Years<br />
                    {{ patientPhoneNum }}<br />
                    {{ patientEmail }}<br />
                    {{ patientAddress }}
                  </ng-container>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="vertical-separator"></div>
        <div class="general-content-container pre-appointment-container" *ngIf="!activeAppointment">
          <span class="container-title">No Pending Appointments</span>
        </div>
        <div class="general-content-container pre-appointment-container" *ngIf="activeAppointment">
          <div>
            <span class="container-title">Pre-Appointment Check-in </span>
            <span *ngIf="activeAppointment.enumApptStatusId === enumConfirmedStatus"> ( Confirmed )</span>
            <span *ngIf="!activeAppointment.isCancelled && activeAppointment.enumApptStatusId !== enumConfirmedStatus"> ( Not Confirmed - <span
                class="text-button" style="padding: 5px;"
                (click)="confirmAppointment(activeAppointment)">Confirm Now</span> )</span>
          </div>

          <table class="pre-appointment-data">
            <tr>
              <td>
                <div>
                  <div>{{ activeAppointment.appointmentDate.format('MMMM D YYYY') }}</div>
                  <div>{{ activeAppointment.appointmentDate.format('dddd, H:mm A')}}</div>
                </div>
              </td>
              <td>
                <div>
                  <div><i class="tiny-icon material-symbols-outlined">stethoscope</i> with {{ activeAppointment.doctor
                    }}</div>
                  <div><i class="tiny-icon material-symbols-outlined">dentistry</i>{{
                    activeAppointment.procedureDescription }}</div>
                </div>
              </td>
              <td>
                <div>
                  <div><i class="tiny-icon material-symbols-outlined">map</i> {{ activeAppointment.locationAddress }}
                  </div>
                  <div><i class="tiny-icon material-symbols-outlined">call</i> {{ activeAppointment.locationPhone }}
                  </div>
                </div>
              </td>
            </tr>
            <tr>
              <td colspan="4">
                <div class="horizontal-separator"></div>
              </td>
            </tr>
            <tr>
              <td colspan="2">
                <div>
                  <div>For Check-in</div>
                  <div style="display: flex;">

                    <div class="button" style="width: 160px;margin-top: 5px;" color="primary"
                      [class.disabled-content]="activeAppointment.isOld || activeAppointment.smsSent || isSendingSMS"
                      (click)="sendToMobile()" (onKeyPress)="SendToMobileKey($event)">
                      <span *ngIf="!isSendingSMS">Send to my Mobile</span>
                      <mat-spinner class="mini-spinner" *ngIf="isSendingSMS" [diameter]="20"></mat-spinner>
                    </div>
                    <div class="button" style="width: 100px;margin-top: 5px; margin-left: 15px;" color="primary"
                      [class.disabled-content]="activeAppointment.isOld" (click)="printAppointment(activeAppointment)">
                      Print</div>
                    <div>
                      <img alt="Open Map"
                        style="height: 35px; cursor: pointer;float: right;margin-top: 5px; margin-left: 15px;"
                        (click)="openMap()" src="assets/Images/map-icon.png">
                    </div>
                  </div>
                </div>
              </td>
              <td>
                <div>
                  <div>Complete Your Forms</div>
                  <div class="general-content-container" *ngIf="!formsLoading">
                    <div class="no-task-message" *ngIf="!formsPending?.length">
                      You have no tasks due at this time.
                    </div>
                    <div class="task-name" *ngIf="formsPending?.length>0">
                      You have {{ formsPending.length }} pending forms.
                    </div>
                  </div>
                </div>
                <div *ngIf="activeAppointment.correspondence.length>0" class="button"
                  style="width: 120px;margin-top: 5px; margin-left: 15px;" color="primary"
                  (click)="openCorrespondence(activeAppointment.AppointmentId)">Correspondence</div>
              </td>
              <td>
              </td>
            </tr>
          </table>
        </div>
      </div>
    </div>

    <div class="content-container">
      <div class="container-title">Upcoming Appointments</div>
      <div class="general-container">
        <div class="general-content-container">
          <div class="general-content-container pre-appointment-container" *ngIf="appointments?.length===0">
            <span class="container-title">No Pending Appointments</span>
          </div>
          <div class="appointment" [disabled] ="appointment.isCancelled" (click)="selectAppointment(appointment)" *ngFor="let appointment of appointments">
            <div class="appointment-content" 
              [class.appointment-active]="activeAppointmentId === appointment.AppointmentId">
              <div class="appointment-upcoming-data">
                <div class="appointment-title">{{ appointment.displayTitle }} </div>
                <br>{{ appointment.procedureDescription }}
                <br>{{ appointment.doctor }}
                <br>{{ appointment.locationAddress }}
              </div>

              <div class="appointment-actions" [class.disabled-content]="appointment.isOld" style="float:right">
                <div *ngIf="!appointment.isCancelled" class="button" style="width: 160px;margin-top: 5px;" color="primary"
                  [class.disabled-content]="appointment.enumApptStatusId === enumConfirmedStatus || appointment.isOld"
                  (click)="confirmAppointment(appointment)">{{ appointment.enumApptStatusId ===
                  enumConfirmedStatus ?
                  'Confirmed' : 'Confirm Appointment' }}</div>
                <div *ngIf="!appointment.isCancelled" class="button" style="width: 160px;margin-top: 5px;" color="primary"
                  [class.disabled-content]="appointment.isOld" (click)="rescheduleAppointment(appointment)">Request
                  Reschedule</div>
                  <div *ngIf="appointment.isCancelled" class="button" style="width: 160px;margin-top: 5px;" color="primary">Cancelled</div>
              </div>
            </div>
            <div class="vertical-separator"></div>
          </div>
        </div>
      </div>
    </div>


    <div class="content-container forms-container">
      <div class="container-title" style="height: 30px">Forms</div>
      <div class="general-container"
        style="min-height: calc(100% - 50px);max-height: calc(100% - 50px);overflow: hidden;">
        <div class="general-content-container" style="width: 100%">
          <div class="form-list">
            <div class="form-tile" [class.active-form]="selectedTreatmentPlanningID === treatment.TreatmentPlanningID"
              data-cy="patient-portal-treatment"
              [class.form-completed]="['Accepted', 'Rejected'].includes(treatment.Status)"
              (click)="loadTreatmentToContainer(treatment)" *ngFor="let treatment of patientTreatments">
              <span data-cy="patient-portal-form-description"
                style="color: var(--accented-text-color);font-size: medium; font-weight: 600;">{{treatment.ParentDescription}}
                - {{treatment.Description}}</span><br />
              Status: <span style="font-size: medium;" data-cy="patient-portal-status"
                [class.status-completed]="'Accepted' === treatment.Status">{{treatment.Status}}</span>
            </div>
            <div class="form-tile" [class.active-form]="selectedCaseWorkItemFormsID === patientForm.CaseWorkItemFormsId"
              data-cy="patient-portal-form"
              [class.form-completed]="['Completed/Signed', 'Completed'].includes(patientForm.Status)"
              (click)="loadFormToContainer(patientForm)" *ngFor="let patientForm of patientForms">
              <span data-cy="patient-portal-form-description"
                style="color: var(--accented-text-color);font-size: medium; font-weight: 600;">{{patientForm.Description}}</span><br />
              Status: <span style="font-size: medium;" data-cy="patient-portal-status"
                [class.status-completed]="['Completed/Signed', 'Completed'].includes(patientForm.Status)">{{patientForm.Status}}</span>
            </div>
          </div>
          <app-case-form-view style="width: 100%; overflow-x: hidden;"></app-case-form-view>
        </div>
      </div>
    </div>
  </div>

  <div [class.main-right-container]="!isRightPanelMinimized"
    [class.main-right-container-contracted]="isRightPanelMinimized">
    <span class="panel-toggle">
      <span class="material-symbols-outlined" style="margin-right:10px;" matTooltip="Expand Panel"
        (click)="toggleRightPanel()" *ngIf="isRightPanelMinimized">
        chevron_left
      </span>
      <span class="material-symbols-outlined" style="margin-right:10px;" matTooltip="Collapse Panel"
        (click)="toggleRightPanel()" *ngIf="!isRightPanelMinimized">
        chevron_right
      </span>
    </span>
    <div class="content-container" [ngStyle]="{'display': (!isRightPanelMinimized) ? '' : 'none' }">
      <div class="general-content-container calendar-container">

        <app-tdo-mini-calendar #calendar [isGetAppointmentDays]="false" [daysToHighlight]="daysToHighlight"
          style="width: 350px;" (selectedDateChange)="calendarUpdate($event)"></app-tdo-mini-calendar>
        <div class="button" style="width: 160px;margin-top: 5px;" color="primary"
          (click)="requestAppointment(appointment)">Request Appointment</div>
      </div>
    </div>

    <div class="content-container" [ngStyle]="{'display': (!isRightPanelMinimized) ? '' : 'none' }">
      <div class="container-title">Recent Appointments</div>
      <div class="recent-appointments-container">
        <div class="general-content-container recent-appointment-container" *ngIf="oldAppointments?.length===0">
          <span class="container-title">No Previous Appointments</span>
        </div>

        <div class="appointment-data recent-entity" *ngFor="let appt of oldAppointments"
          style="display: flex;flex-flow: column;">
          <div style="flex-direction: row; display: flex;">
            <div style="flex-direction: row; display: flex;width: 140px; flex-basis: 150px; margin:auto;">
              <div style="font-size: xx-large;width: 40px; font-weight: 700;">{{ appt.appointmentDate.format('D') }}
              </div>
              <div style="width: 100px;">{{ appt.appointmentDate.format('MMM, YYYY')}}<br />{{
                appt.appointmentDate.format('H:mm A')}}
              </div>
            </div>
            <div style="font-size: small; width: 200px;">
              <div><i class="tiny-icon material-symbols-outlined">stethoscope</i> {{ appt.doctor }}</div>
              <div><i class="tiny-icon material-symbols-outlined">dentistry</i> {{ appt.procedureDescription }}</div>
            </div>
            <div style="font-size: small; width: 200px;">
              <div><i class="tiny-icon material-symbols-outlined">map</i> {{ appt.locationAddress }}</div>
              <div><i class="tiny-icon material-symbols-outlined">call</i> {{ appt.locationPhone }}</div>
            </div>
          </div>
          <div *ngIf="appt.correspondence.length>0" style="text-align: center;"
            (click)="openCorrespondence(appt.AppointmentId)">
            <div class="correspondence-label">Correspondence</div>
          </div>
        </div>
      </div>
    </div>

    <div class="content-container" [ngStyle]="{'display': (!isRightPanelMinimized) ? '' : 'none' }">
      <div class="container-title">Pending Payments</div>
      <div class="recent-invoices-container">
        <div class="general-content-container recent-appointment-container" *ngIf="patientTransactions?.length===0">
          <span class="container-title">No Pending Transactions</span>
        </div>


        <div class="transaction-data recent-entity" style="display: flex;flex-flow: column;"
          *ngFor="let transaction of patientTransactions">
          <div style="flex-direction: row; display: flex;">
            <div style="flex-direction: row; display: flex;width: 140px; flex-basis: 150px;margin: auto;">
              <div style="font-size: xx-large;width: 40px; font-weight: 700;">{{
                transaction.ItemDate.format('D') }}</div>
              <div style="width: 100px;">{{ transaction.ItemDate.format('MMM, YYYY')}}<br />{{
                transaction.ItemDate.format('H:mm A')}}
              </div>
            </div>
            <div style="font-size: small; width: 200px;">
              <div><i class="tiny-icon material-symbols-outlined">stethoscope</i> Dr. {{ transaction.DoctorName }}</div>
              <div><i class="tiny-icon material-symbols-outlined">map</i> {{ transaction.LocationName }}</div>
            </div>
            <div style="width: 100px; margin: auto;">
              <div>{{ transaction.AmountDuePatient | currency }}</div>
            </div>
          </div>
          <div style="text-align: center;">
            <div class="payment-pending">Your payment of {{transaction.AmountDuePatient | currency}} is due</div>
          </div>
        </div>

      </div>
    </div>
  </div>
</div>
<div *ngIf="!isLoading && (isTabletPortrait || isTabletLandscape)" class="tablet-container" [ngClass]="{'ipad-device': isIPad}" style="overflow-y: auto !important;">
  <mat-accordion class="headers-align" multiple="false">
    <mat-expansion-panel>
      <mat-expansion-panel-header class="panel-style">
        <mat-panel-title> Patient Information </mat-panel-title>
      </mat-expansion-panel-header>
      <div class="general-content-container profile-container">
        <div class="profile-image" (click)="activateImageView()">
          <app-file-manager-view #imageView [width]="150" [height]="150" [roundImage]="false" [roundCorners]="true"
            [orientation]="'fixed'" viewType="single" previewType="patient" [LOCID]="LOCID"
            enumDocumentTypeID="0000001C-1000-0000-0000-000000000003" [enumDocumentTags]="[DOCUMENT_TAG.PatientPicture]"
            [PatientId]="PatientId"></app-file-manager-view>
        </div>
        <div class="profile-info">
          <div class="profile-action-buttons">
            <div class="warning-icon-container" [matTooltip]="patientMissingInfo">
              <i *ngIf="!patientInformationComplete" class="material-icons warning-icon"
                alt="Patient information incomplete">warning</i>
            </div>
            <div class="button" style="width: 60px;float: right;" color="primary" (click)="editProfilePressed()">Edit
            </div>
          </div>
          <!--PROFILE DATA-->
          <div>
            <div style="color: var(--accented-text-color); font-size: 18px;">
              {{patientInformation.fullname}}
            </div>
            <div class="patient-info">
              <span style="color: var(--tdo-light-gray);">Patient # {{Patient?.PatientNO}}</span>
              <div class="appointment-data">
                <ng-container>
                  {{ patientBirthday?.format('DD MMM, YYYY') }}<br />
                  {{ patientBirthday? moment().diff(patientBirthday,'years') : '--'}} Years<br />
                  {{ patientPhoneNum }}<br />
                  {{ patientEmail }}<br />
                  {{ patientAddress }}
                </ng-container>
              </div>
            </div>
          </div>
        </div>
      </div>
    </mat-expansion-panel>
    <mat-expansion-panel>
      <mat-expansion-panel-header class="panel-style">
        <mat-panel-title> Appointment Information </mat-panel-title>
      </mat-expansion-panel-header>
      <div class="general-content-container pre-appointment-container" *ngIf="!activeAppointment">
        <span class="container-title">No Pending Appointments</span>
      </div>
      <div class="general-content-container pre-appointment-container" *ngIf="activeAppointment">
        <div>
          <span class="container-title">Pre-Appointment Check-in </span>
          <span *ngIf="activeAppointment.enumApptStatusId === enumConfirmedStatus"> ( Confirmed )</span>
          <span *ngIf="activeAppointment.enumApptStatusId !== enumConfirmedStatus"> ( Not Confirmed - <span
              class="text-button" style="padding: 5px;"
              (click)="confirmAppointment(activeAppointment)">Confirm Now</span> )</span>
        </div>
        <table class="pre-appointment-data">
          <tr>
            <td>
              <div>
                <div>{{ activeAppointment.appointmentDate.format('MMMM D YYYY') }}</div>
                <div>{{ activeAppointment.appointmentDate.format('dddd, H:mm A')}}</div>
              </div>
            </td>
            <td>
              <div>
                <div><i class="tiny-icon material-symbols-outlined">stethoscope</i> with {{ activeAppointment.doctor
                  }}</div>
                <div><i class="tiny-icon material-symbols-outlined">dentistry</i>{{
                  activeAppointment.procedureDescription }}</div>
              </div>
            </td>
            <td>
              <div>
                <div><i class="tiny-icon material-symbols-outlined">map</i> {{ activeAppointment.locationAddress }}
                </div>
                <div><i class="tiny-icon material-symbols-outlined">call</i> {{ activeAppointment.locationPhone }}
                </div>
              </div>
            </td>
          </tr>
          <tr>
            <td colspan="4">
              <div class="horizontal-separator"></div>
            </td>
          </tr>
          <tr>
            <td colspan="2">
              <div>
                <div>For Check-in</div>
                <div style="display: flex;">
                  <div class="button" style="width: 160px;margin-top: 5px;" color="primary"
                    [class.disabled-content]="activeAppointment.isOld || activeAppointment.smsSent || isSendingSMS"
                    (click)="sendToMobile()" (onKeyPress)="SendToMobileKey($event)">
                    <span *ngIf="!isSendingSMS">Send to my Mobile</span>
                    <mat-spinner class="mini-spinner" *ngIf="isSendingSMS" [diameter]="20"></mat-spinner>
                  </div>
                  <div class="button" style="width: 100px;margin-top: 5px; margin-left: 15px;" color="primary"
                    [class.disabled-content]="activeAppointment.isOld" (click)="printAppointment(activeAppointment)">
                    Print</div>
                  <div>
                    <img alt="Open Map"
                      style="height: 35px; cursor: pointer;float: right;margin-top: 5px; margin-left: 15px;"
                      (click)="openMap()" src="assets/Images/map-icon.png">
                  </div>
                </div>
              </div>
            </td>
            <td>
              <div>
                <div>Complete Your Forms</div>
                <div class="general-content-container" *ngIf="!formsLoading">
                  <div class="no-task-message" *ngIf="!formsPending?.length">
                    You have no tasks due at this time.
                  </div>
                  <div class="task-name" *ngIf="formsPending?.length>0">
                    You have {{ formsPending.length }} pending forms.
                  </div>
                </div>
              </div>
              <div *ngIf="activeAppointment.correspondence.length>0" class="button"
                style="width: 120px;margin-top: 5px; margin-left: 15px;" color="primary"
                (click)="openCorrespondence(activeAppointment.AppointmentId)">Correspondence</div>
            </td>
            <td>
            </td>
          </tr>
        </table>
      </div>
    </mat-expansion-panel>

    <mat-expansion-panel>
      <mat-expansion-panel-header class="panel-style">
        <mat-panel-title> Upcoming appointments </mat-panel-title>
      </mat-expansion-panel-header>
      <div class="content-container">
        <div class="general-container">
          <div class="general-content-container">
            <div class="general-content-container pre-appointment-container" *ngIf="appointments?.length===0">
              <span class="container-title">No Pending Appointments</span>
            </div>
            <div class="appointment" (click)="selectAppointment(appointment)" *ngFor="let appointment of appointments">
              <div class="appointment-content"
                [class.appointment-active]="activeAppointmentId === appointment.AppointmentId">
                <div class="appointment-upcoming-data">
                  <div class="appointment-title">{{ appointment.displayTitle }} </div>
                  <br>{{ appointment.procedureDescription }}
                  <br>{{ appointment.doctor }}
                  <br>{{ appointment.locationAddress }}
                </div>
                <div class="appointment-actions" [class.disabled-content]="appointment.isOld" style="float:right">
                  <div class="button" style="width: 160px;margin-top: 5px;" color="primary"
                    [class.disabled-content]="appointment.enumApptStatusId === enumConfirmedStatus || appointment.isOld"
                    (click)="confirmAppointment(appointment)">{{ appointment.enumApptStatusId ===
                    enumConfirmedStatus ?
                    'Confirmed' : 'Confirm Appointment' }}</div>
                  <div class="button" style="width: 160px;margin-top: 5px;" color="primary"
                    [class.disabled-content]="appointment.isOld" (click)="rescheduleAppointment(appointment)">Request
                    Reschedule</div>
                </div>
              </div>
              <div class="vertical-separator"></div>
            </div>
          </div>
        </div>
      </div>
    </mat-expansion-panel>

    <mat-expansion-panel #panel>
      <mat-expansion-panel-header class="panel-style">
        <mat-panel-title style="display: flex; align-items: center;">
          <span>Forms</span>
          <div *ngIf="!isLoading && panel.expanded" style="padding-left: 340px;">
            <div *ngIf="isformViewMinimized" matTooltip="Expand Form List" 
                 (click)="toggleFormView($event)" 
                 class="form-view-collapsed">
              <mat-icon style="transform: scale(1.76, 1.7); cursor: pointer;">chevron_right</mat-icon>
            </div>
            <div *ngIf="!isformViewMinimized" matTooltip="Collapse Form List" 
                 (click)="toggleFormView($event)" 
                 class="form-view-collapsed"
                 style="cursor: pointer;">
              <mat-icon style="transform: scale(1.76, 1.7);">chevron_left</mat-icon>
            </div>
          </div>
        </mat-panel-title>
      </mat-expansion-panel-header>
      <div class="content-container forms-container">
        <div class="general-container"
          style="min-height: calc(100% - 50px);max-height: calc(100% - 50px);overflow: hidden;">
          <div class="general-content-container" style="width: 100%">
            <div class="form-listTablet" *ngIf="!isformViewMinimized">
              <div class="form-tile" [class.active-form]="selectedTreatmentPlanningID === treatment.TreatmentPlanningID"
                data-cy="patient-portal-treatment"
                [class.form-completed]="['Accepted', 'Rejected'].includes(treatment.Status)"
                (click)="loadTreatmentToContainer(treatment)" *ngFor="let treatment of patientTreatments">
                <span data-cy="patient-portal-form-description"
                  style="color: var(--accented-text-color);font-size: small; font-weight: 600;">{{treatment.ParentDescription}}
                  - {{treatment.Description}}</span><br />
                Status: <span style="font-size: smaller;" data-cy="patient-portal-status"
                  [class.status-completed]="'Accepted' === treatment.Status">{{treatment.Status}}</span>
              </div>
              <div class="form-tile"
                [class.active-form]="selectedCaseWorkItemFormsID === patientForm.CaseWorkItemFormsId"
                data-cy="patient-portal-form"
                [class.form-completed]="['Completed/Signed', 'Completed'].includes(patientForm.Status)"
                (click)="loadFormToContainer(patientForm)" *ngFor="let patientForm of patientForms">
                <span data-cy="patient-portal-form-description"
                  style="color: var(--accented-text-color);font-size: small; font-weight: 600;">{{patientForm.Description}}</span><br />
                Status: <span style="font-size: smaller;" data-cy="patient-portal-status"
                  [class.status-completed]="['Completed/Signed', 'Completed'].includes(patientForm.Status)">{{patientForm.Status}}</span>
              </div>
            </div>
            <ng-container>
              <app-case-form-view class="form-Tablet" style="overflow-x: hidden;"></app-case-form-view>
            </ng-container>
          </div>
        </div>
      </div>
    </mat-expansion-panel>
    <mat-expansion-panel>
      <mat-expansion-panel-header class="panel-style">
        <mat-panel-title> Recent appointments </mat-panel-title>
      </mat-expansion-panel-header>
      <div class="content-container">
        <div class="general-content-container calendar-container">
          <app-tdo-mini-calendar #calendar [isGetAppointmentDays]="false" [daysToHighlight]="daysToHighlight"
            style="width: 350px;" (selectedDateChange)="calendarUpdate($event)"></app-tdo-mini-calendar>
          <div class="button" style="width: 160px;margin-top: 5px;" color="primary"
            (click)="requestAppointment(appointment)">Request Appointment</div>
        </div>
      </div>
      <div class="content-container">
        <div class="container-title">Recent Appointments</div>
        <div class="recent-appointments-container">
          <div class="general-content-container recent-appointment-container" *ngIf="oldAppointments?.length===0">
            <span class="container-title">No Previous Appointments</span>
          </div>
          <div class="appointment-data recent-entity" *ngFor="let appt of oldAppointments"
            style="display: flex;flex-flow: column;">
            <div style="flex-direction: row; display: flex;">
              <div style="flex-direction: row; display: flex;width: 140px; flex-basis: 150px; margin:auto;">
                <div style="font-size: xx-large;width: 40px; font-weight: 700;">{{ appt.appointmentDate.format('D') }}
                </div>
                <div style="width: 100px;">{{ appt.appointmentDate.format('MMM, YYYY')}}<br />{{
                  appt.appointmentDate.format('H:mm A')}}
                </div>
              </div>
              <div style="font-size: small; width: 200px;">
                <div><i class="tiny-icon material-symbols-outlined">stethoscope</i> {{ appt.doctor }}</div>
                <div><i class="tiny-icon material-symbols-outlined">dentistry</i> {{ appt.procedureDescription }}</div>
              </div>
              <div style="font-size: small; width: 200px;">
                <div><i class="tiny-icon material-symbols-outlined">map</i> {{ appt.locationAddress }}</div>
                <div><i class="tiny-icon material-symbols-outlined">call</i> {{ appt.locationPhone }}</div>
              </div>
            </div>
            <div *ngIf="appt.correspondence.length>0" style="text-align: center;"
              (click)="openCorrespondence(appt.AppointmentId)">
              <div class="correspondence-label">Correspondence</div>
            </div>
          </div>
        </div>
      </div>
    </mat-expansion-panel>

    <mat-expansion-panel>
      <mat-expansion-panel-header class="panel-style">
        <mat-panel-title> Pending Payments</mat-panel-title>
      </mat-expansion-panel-header>
      <div class="content-container">
        <div class="recent-invoices-container">
          <div class="general-content-container recent-appointment-container" *ngIf="patientTransactions?.length===0">
            <span class="container-title">No Pending Transactions</span>
          </div>
          <div class="transaction-data recent-entity" style="display: flex;flex-flow: column;"
            *ngFor="let transaction of patientTransactions">
            <div style="flex-direction: row; display: flex;">
              <div style="flex-direction: row; display: flex;width: 140px; flex-basis: 150px;margin: auto;">
                <div style="font-size: xx-large;width: 40px; font-weight: 700;">{{
                  transaction.ItemDate.format('D') }}</div>
                <div style="width: 100px;">{{ transaction.ItemDate.format('MMM, YYYY')}}<br />{{
                  transaction.ItemDate.format('H:mm A')}}
                </div>
              </div>
              <div style="font-size: small; width: 200px;">
                <div><i class="tiny-icon material-symbols-outlined">stethoscope</i> Dr. {{ transaction.DoctorName }}
                </div>
                <div><i class="tiny-icon material-symbols-outlined">map</i> {{ transaction.LocationName }}</div>
              </div>
              <div style="width: 100px; margin: auto;">
                <div>{{ transaction.AmountDuePatient | currency }}</div>
              </div>
            </div>
            <div style="text-align: center;">
              <div class="payment-pending">Your payment of {{transaction.AmountDuePatient | currency}} is due</div>
            </div>
          </div>
        </div>
      </div>
    </mat-expansion-panel>

  </mat-accordion>
</div>
<div class="main-container" *ngIf="!isLoading && isHandsetPortrait">
  <div class="not-visible-message">
    This website is not visible on phone devices. Please use a tablet or desktop for the best experience.
  </div>
</div>
<div *ngIf="isLoading" class="spinner-container">
  <mat-spinner></mat-spinner>
</div>